<template>
  <section class="row">
    <div class="col-12">
      <div class="card shadow">
        <div
          class="card-body px-md-4 py-md-5 rounded-4 py-4 transition-shadow
            box-shadow-green-300 box-shadow-hover-green-300"
        >
          <div class="row">
            <div class="col-1 pe-0">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-10">
              <div class="h5 text-center mb-3">
                Ajouter un RIB
              </div>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <div class="row">
                <div class="col-12">
                  <stripe-iban
                    v-if="useStripeIban"
                    is-setup-mode
                    element-id="account-stripe-iban"
                    module-name="payments"
                    submit-title="Enregistrer mon nouveau RIB"
                    @payment:success="onSuccess"
                    @form:error="onError"
                  />
                  <go-cardless-iban
                    v-else
                    is-setup-mode
                    api-scope="payments"
                    module-name="payments"
                    is-description-visible="true"
                    @payment:success="onSuccess"
                    @form:error="onError"
                  />
                </div>
                <div
                  v-if="error"
                  class="col-12"
                >
                  <div class="text-danger text-center mt-2">
                    {{ error }}
                  </div>
                </div>
                <div class="col-12 mt-4">
                  <button
                    type="button"
                    class="btn btn-block w-100"
                    @click="() => $router.back()"
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import StripeIban from '@/components/checkout/stripe/StripeIban.vue';
import GoCardlessIban from '@/components/checkout/gocardless/GoCardlessIban.vue';
import { ui, contracts as contractsMixin } from '@/mixins';

export default {
  name: 'AccountPaymentAddSepa',
  components: {
    'stripe-iban': StripeIban,
    'go-cardless-iban': GoCardlessIban,
  },
  mixins: [ui, contractsMixin],
  emits: ['show', 'cancel'],
  data() {
    return {
      error: null,
    };
  },
  computed: {
    useStripeIban() {
      return !this.useGoCardless;
    },
  },
  async mounted() {
    await this.ensureContractsLoaded();
  },
  methods: {
    onSuccess() {
      this.ui_accountModal({ type: 'sepa', value: true });
      this.$emit('show', false);
    },
    onError(err) {
      console.error(err);
      this.error = 'Erreur, veuillez réessayer ultérieurement';
    },
    cancelForm() {
      this.$emit('cancel');
    },
  },
};
</script>
